import { useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Logo } from "../../components/site/Logo";
import { useAuth } from "../../lib/auth";
import { errorText } from "../../lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(location.state?.error || "");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const google = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      setError(errorText(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="grid min-h-screen place-items-center bg-canvas px-5">
      <title>Admin login | The Catalyst</title>
      <meta name="robots" content="noindex" />
      <form onSubmit={submit} className="w-full max-w-sm rounded-[1.75rem] border border-ink/10 bg-white p-8" data-testid="admin-login-form">
        <Logo />
        <h1 className="mt-8 font-display text-3xl font-bold text-ink">Team sign in</h1>
        <p className="mt-2 text-sm text-ink/65">For The Catalyst team and approved staff only.</p>
        <button type="button" onClick={google} className="mt-6 flex w-full items-center justify-center gap-3 rounded-full border border-ink/15 bg-white py-3 text-sm font-semibold text-ink transition-colors hover:border-ink" data-testid="admin-google-login">
          <svg viewBox="0 0 48 48" className="h-5 w-5" aria-hidden="true"><path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z"/><path fill="#FF3D00" d="m6.3 14.7 6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/><path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-8l-6.5 5C9.5 39.6 16.2 44 24 44z"/><path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z"/></svg>
          Continue with Google
        </button>
        <div className="my-6 flex items-center gap-3 text-xs text-ink/50"><span className="h-px flex-1 bg-ink/10" />or use email<span className="h-px flex-1 bg-ink/10" /></div>
        <label className="block text-sm font-semibold text-ink" htmlFor="admin-email">Email</label>
        <input id="admin-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 w-full rounded-xl border border-ink/15 px-4 py-3 outline-none focus:border-ink" data-testid="admin-email-input" />
        <label className="mt-4 block text-sm font-semibold text-ink" htmlFor="admin-password">Password</label>
        <input id="admin-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 w-full rounded-xl border border-ink/15 px-4 py-3 outline-none focus:border-ink" data-testid="admin-password-input" />
        {error && <p className="mt-4 text-sm text-flame-dark" role="alert" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={busy} className="btn-primary mt-6 w-full" data-testid="admin-login-submit">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Sign in"}
        </button>
      </form>
    </main>
  );
}
